import { OrganizationManager } from "../components/OrganizationManager";
import { PageHeader } from "../components/PageHeader";

export function AreasPage() {
  return <div className="page"><PageHeader eyebrow="Ongoing responsibilities" title="Areas" subtitle="Create, order, archive, and restore Areas, and manage Tags used across content." /><OrganizationManager /></div>;
}
